import { render } from "./dashboard-layout.vue?vue&type=template&id=f66ea4c0"
import script from "./dashboard-layout.vue?vue&type=script&lang=js"
export * from "./dashboard-layout.vue?vue&type=script&lang=js"

import "./dashboard-layout.vue?vue&type=style&index=0&id=f66ea4c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__